import { bindServices } from '@/services/api';
import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { queryEntityActivate, queryEntityFields } from './service';

const api = bindServices('configEntity');

const meta = { page: 1, limit: 5, count: 0, totalPages: 0 };

const initialState = {
  selectedItem: null,
  formConfig: null,
  list: [],
  fieldsList: [],
  pagination: meta,
  fieldsPagination: meta,
  orderBy: '',
  newEntity: false,
  view: false,
  searchCriteria: null,
};

const Model = {
  namespace: 'configEntity',
  state: initialState,
  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const res = yield call(api.getAll, {
          route: 'dynamicEntity/paged',
          params: payload,
        });
        yield put({
          type: 'queryEntities',
          payload: {
            ...res,
            ..._.pick(payload, ['page', 'limit']),
          },
        });
      } catch (e) {}
    },

    *editActive({ payload }, { call, put }) {
      try {
        yield call(queryEntityActivate, payload.id, payload.state);
        yield put({ type: 'entityActive', payload });
      } catch (e) {}
    },

    *addEntity({ payload }, { call, put }) {
      try {
        yield call(api.create, {
          route: 'dynamicEntity',
          data: payload.data,
        });
        yield put({ type: 'fetchList', payload: payload.params });
        yield put({
          type: 'global/showNotificationGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'addForm', payload: false });
      } catch (e) {
        if (e.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: e.message,
            },
            validationErrors: e.validationErrors,
          });
        }
      }
    },

    *deleteEntity({ payload }, { call, put }) {
      try {
        yield put({ type: 'global/modalConfirm', state: false, id: null });
        yield call(api.apiRoute, {
          route: `dynamicEntity/${payload.id}`,
          method: 'delete',
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        if (payload.routed) yield put({ type: 'entity/onDelete' });
        yield put({ type: 'fetchList', payload: payload.params });
      } catch (e) {
        if (e.message) {
          yield put({ type: 'global/modalConfirm', state: false, id: null });
          yield put({
            type: 'global/showNotificationGlobal',
            payload: { visible: true, type: 'error' },
          });
        }
      }
    },

    *queryEntityFields({ payload }, { call, put }) {
      try {
        const response = yield call(queryEntityFields, payload);
        yield put({ type: 'entityFields', payload: response });
      } catch (e) {}
    },

    *search({ payload }, { put }) {
      yield put({ type: 'querySearch', payload });
    },

    *showAddForm({ payload }, { put }) {
      yield put({ type: 'addForm', payload });
    },

    *hideAllForms(o, { put }) {
      yield put({ type: 'hideForms' });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'orderBy', payload });
    },
  },

  reducers: {
    queryEntities(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: {
          ...state.pagination,
          ...payload,
          ...toPaginate(payload),
        },
      };
    },

    entityActive(state, { payload }) {
      return {
        ...state,
        list: _.map(state.list, (o) => {
          if (o.id === payload.id) _.set(o, 'isActive', payload.state);
          return o;
        }),
      };
    },

    entityById(state, { payload }) {
      return {
        ...state,
        selectedItem: payload,
      };
    },

    entityFields(state, { payload }) {
      return {
        ...state,
        fieldsList: payload.items,
        fieldsPagination: {
          ...state.fieldsPagination,
          ...payload,
          ...toPaginate(payload),
        },
      };
    },

    querySearch(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    addForm(state, { payload }) {
      return {
        ...state,
        newEntity: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        selectedItem: null,
        newEntity: false,
      };
    },
  },
};

export default Model;
